<script setup>
import { markRaw } from 'vue';

// eslint-disable-next-line no-undef
defineProps({
    icon: {
        type: String,
        required: false,
    },
    title: {
        type: String,
        required: false,
    },
    severity: {
        type: String,
        default: 'info',
    },
});

const messagePt = markRaw({
    wrapper: 'tw-gap-8 tw-text-left !tw-py-8',
});
</script>

<template>
    <Message :severity="severity" :closable="false" :pt="messagePt">
        <template #messageicon>
            <div class="tw-bg-white tw-inline-flex tw-p-3 tw-rounded-full">
                <i :class="icon" class="tw-text-4xl"></i>
            </div>
        </template>

        <div>
            <h4 v-if="title" class="tw-mb-3">{{ title }}</h4>
            <slot />
        </div>
    </Message>
</template>
